import { links } from '../../../../../../constants/links';
import {
  setFlatsTablePage,
  setHousesTablePage,
} from '../../../../../../store/actions/housingStockActions';
import { modes } from '../constants';

const housePages = links.house.pages;

export const getMode = ({ page, pageTab, isFlatsTableView }) => {
  if (page === links.houses) {
    if (!pageTab) {
      return modes.houses;
    }

    if (pageTab === housePages.flats && isFlatsTableView) return modes.flats;
  }

  if (page === links.tenants || pageTab === housePages.tenants) {
    return modes.tenants;
  }

  if (
    page === links.personalAccounts ||
    pageTab === housePages.personalAccounts
  ) {
    return modes.accounts;
  }

  return modes.houses;
};

export const flatsViewSelector = (state) => state.housingStockStore.flatsView;
export const searchSelector = (state) =>
  state.housingStockStore.searchFieldValue;

export const searchChangeCb = (mode, dispatch) => {
  switch (mode) {
    case modes.houses:
      dispatch(setHousesTablePage(0));
    case modes.flats:
      dispatch(setFlatsTablePage(0));
    default:
      return;
  }
};
